import React from "react";
import ContactForm from './ContactForm';
import { connect } from 'react-redux';
import sendMessage from './SendMessage';
import * as contactActions from '../../actions/contact';
import ReactHtmlParser from 'react-html-parser';

class Contact extends React.Component {
  componentDidMount() {
    this.props.dispatch(contactActions.loadContact());
  }

  render() {
    const { contact, error } = this.props.contact;
    const loading = this.props.loading;

    if(loading.loading) { return <section id="contact" ref={this.props.innerRef} /> }
    if(error) { return "error" }

    return (
      <section id="contact" ref={this.props.innerRef}>
        <div className="row section-head">
          <div className="twelve columns header-col">
            <h2>Get In Touch</h2>
          </div>
        </div>
        <div className="row">
          <div className="eight columns">
            <ContactForm onSubmit={sendMessage} />

            <div id="message-warning"> Error boy</div>

            <div id="message-success">
              <i className="fa fa-check" />Your message was sent, thank you!<br />
            </div>
          </div>
          <aside className="four columns footer-widgets">
            <div className="widget widget_contact">
              <h4>My Info</h4>
              <p className="address">{ReactHtmlParser(contact.filter(item => item.name === "contact")[0].content)}</p>
            </div>
          </aside>
        </div>
      </section>

    )
  }
}

const mapStateToProps = state => ({
  ...state,
  contact: state.contact
});

export default connect(mapStateToProps, null, null, {withRef: true})(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js